import adminAxios from "@/shared/api/adminAxiosInstance";

export const getPrivateGames = (params) => {
    return adminAxios.get('/admin/private-game-requests', { params });
}

export const getPrivateGameById = (id) => {
    return adminAxios.get(`/admin/private-game-requests/${id}`);
}

export const putStatus = (id, status) => {
    return adminAxios.put(`/admin/private-game-requests/${id}/status`, {status});
}